import React from 'react';
import './Cards.css';
import './Button.css';
import { Button }  from './Button';



function Cards() {
  const scrollToBottom = () => window.scrollTo({
    top: 500,
    behavior: "smooth"
  });
  return (
    <div className='cards'>
      <div style={{textAlign:'center'}}>
        <a className='itaclogo' href='https://indigenoustourism.ca/'>
          <img alt='ITAC Logo' src="images/itac-logo-fr-en.png"></img>
        </a>
      </div>
      <div style={{margin:'auto', width:'70%'}}><h2>Introduction: </h2>
      <h3><br></br>The Indigenous Tourism Association of Canada (ITAC) partnered with iTOTEM Analytics to assess the economic and social benefits of investment in Indigenous tourism infrastructure.
      <div><br></br>Aligned with ITAC’s strategic recovery plan and vision for the industry, the results from the initiative will be invaluable for ITAC’s advocacy efforts as the organization advocates for increased investment and program supports to be made available to Indigenous tourism operators between 2022-2024. The insights will help inform the action plan by highlighting how the Indigenous tourism industry has sustainably thrived in the past and help us understand the adjustments needed to get back on track.</div>
      <div><br></br>Note: for data integration purposes, entry fields cannot include commas or dollar signs. When a question asks for a monetary amount, please enter the associated integer and ensure the number of zeroes is correct (i.e. enter 10000 for $10,000).</div>
      </h3></div>
      <div style={{margin:'auto'}}><br></br>
      <iframe 
            name="ITAC Form" 
            width="1300px"
            height="9000px" 
            frameborder="0"
            margin='auto' 
            marginheight="0" 
            marginwidth="0"
            // scrolling='no'
            title="Survey" 
            src="https://ee.kobotoolbox.org/x/JTpU9h9a"
            >
      </iframe>
      
      </div >
      <div style={{margin:'auto', width:'70%', textAlign:'center'}}>
        After pressing the save draft button scroll up to confirm
        <div className='hero-btns' style={{textAlign:'center'}}>
          <br></br>
          <div></div>
          <Button
            style={{margin:'auto', width:'70%'}}
            className='btns'
            buttonStyle='btn--outline-black'
            buttonSize='btn--large'
            onClick = {scrollToBottom}
          >
            Go to top
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Cards;
